module.exports = __webpack_public_path__ + "static/media/world_scribe_2_icon.b343edcd.svg";